import i18n from "../../../../../i18n";
import { required, same, validateError } from "../../../../../utils/validate";
import { useForm as createUseForm } from "@ant-design-vue/use";
import { setIsLoading as setIsLoadingApp } from "../../../../../app.logic";
import store from "../../../../../store";
import { Input } from "ant-design-vue";

export const actionPrefix = "resource/v1/security/user";

export const callChangePassword = ({ form }) =>
    store.dispatch(`${actionPrefix}/changePassword`, { data: { id: form.id, password: form.newPassword } });

export const onClickChangePassword = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => {
            setIsLoadingApp(true);
            return callChangePassword({ form: data.useForm.modelRef }).finally(() => setIsLoadingApp(false));
        })
        .catch(error => {
            validateError({ error });
            throw error;
        });
};

export const createForm = ({ props }) => {
    return {
        id: props.id,
        presentPassword: null,
        newPassword: null,
        confirmPassword: null
    };
};

export const createRules = ({ data }) => {
    return {
        newPassword: [required],
        confirmPassword: [
            required,
            same(data.form, "newPassword", i18n.global.t("views.changePassword.newPassword"), i18n.global.t("views.changePassword.confirmPassword"))
        ]
    };
};

export const createField = ({ props, data }) => {
    const dirty = {};
    const viewOnly = props.viewOnly;
    const useForm = data.useForm;
    const modelRef = useForm.modelRef;
    return [
        {
            key: "newPassword",
            visible: () => true,
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 9 }, wrapperCol: { xs: 24, md: 15 } }),
            inputRender: ({ field }) => {
                const placeholder = field.label();
                const onBlur = () => {
                    if (dirty["confirmPassword"]) {
                        useForm.validate("confirmPassword").catch(() => {});
                    }
                    useForm.validate("newPassword").catch(() => {});
                };
                return (
                    <Input.Password
                        value={modelRef.newPassword}
                        onUpdate:value={value => (modelRef.newPassword = value)}
                        onBlur={onBlur}
                        placeholder={placeholder}
                        disabled={viewOnly}
                    ></Input.Password>
                );
            },
            label: () => i18n.global.t("views.changePassword.newPassword")
        },
        {
            key: "confirmPassword",
            visible: () => true,
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 9 }, wrapperCol: { xs: 24, md: 15 } }),
            inputRender: ({ field }) => {
                const placeholder = field.label();
                const onBlur = () => {
                    dirty["confirmPassword"] = true;
                    useForm.validate("confirmPassword").catch(() => {});
                };
                return (
                    <Input.Password
                        value={modelRef.confirmPassword}
                        onUpdate:value={value => (modelRef.confirmPassword = value)}
                        onBlur={onBlur}
                        placeholder={placeholder}
                        disabled={viewOnly}
                    ></Input.Password>
                );
            },
            label: () => i18n.global.t("views.changePassword.confirmPassword")
        }
    ];
};

export const initForm = ({ props, data, refs }) => {
    data.form = createForm({ props, data, refs });
    data.rules = createRules({ props, data, refs });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs });
};
